import { track } from "jiffy-analytics";
import { on } from "common/utils/ui/event";

const getActiveCategory = $form =>
  $form.querySelector(".js-masthead-search-dropdown-button[data-active='true']")?.dataset.category;

class MadeCategoryPrintMasthead {
  constructor(root) {
    this.root = root;
    this.handleSearchSubmit = this.handleSearchSubmit.bind(this);
    this.handleMoreSubmenuButtonClick = this.handleMoreSubmenuButtonClick.bind(this);
    this.handleMoreSubmenuOutsideClick = this.handleMoreSubmenuOutsideClick.bind(this);
  }

  get $searchForm() {
    return this.root?.querySelector(".js-masthead-search-form");
  }

  get $searchButton() {
    return this.root?.querySelector(".js-masthead-search-toggle");
  }

  get $searchCloseButton() {
    return this.root?.querySelector(".js-masthead-search-close-button");
  }

  get $logoContainer() {
    return this.root?.querySelector(".js-masthead-logo-container");
  }

  get $searchInputContainer() {
    return this.root?.querySelector(".js-masthead-search-input-container");
  }

  get $userBoxContainer() {
    return this.root?.querySelector(".js-masthead-user-box-container");
  }

  get $moreButton() {
    return this.root?.querySelector('[data-testid="masthead-submenu-more-button"]');
  }

  get $moreContainer() {
    return this.root?.querySelector('[data-category="more-customizable-menu"]');
  }

  handleSearchSubmit(_event) {
    const $form = this.$searchForm;
    if (!$form) return;

    const formData = new FormData($form);
    const params = new URLSearchParams(formData);
    const searchURL = `${$form.action}?${params.toString()}`;

    track("clp_search_button_clicked", {
      filter_category: getActiveCategory($form) || "none",
      search_term: formData.get("query"),
      search_url: searchURL
    });
  }

  bindSearchForm() {
    on("submit", ".js-masthead-search-form", this.handleSearchSubmit, false, this.root);
  }

  bindToggleSearch() {
    const { $searchButton, $searchInputContainer, $logoContainer, $userBoxContainer } = this;

    $searchButton.addEventListener("click", () => {
      $searchInputContainer.classList.add("!flex");
      $logoContainer.classList.add("hidden");
      $userBoxContainer.classList.add("hidden");
    });
  }

  bindSearchCloseButton() {
    const { $searchCloseButton, $searchInputContainer, $logoContainer, $userBoxContainer } = this;

    $searchCloseButton.addEventListener("click", () => {
      $searchInputContainer.classList.remove("!flex");
      $logoContainer.classList.remove("hidden");
      $userBoxContainer.classList.remove("hidden");
    });
  }

  handleMoreSubmenuButtonClick(_event, $target) {
    const $container = this.$moreContainer;
    if (!$container) return;

    const isOpen = $container.classList.toggle("is-open");
    $target.setAttribute("aria-expanded", isOpen);
  }

  handleMoreSubmenuOutsideClick(event) {
    const { $moreContainer, $moreButton } = this;
    if (!$moreContainer?.classList.contains("is-open")) return;
    if ($moreContainer.contains(event.target)) return;

    $moreContainer.classList.remove("is-open");
    $moreButton?.setAttribute("aria-expanded", "false");
  }

  bindMoreSubmenuToggle() {
    const { $moreButton, $moreContainer } = this;
    if (!$moreButton || !$moreContainer) return;

    on(
      "click",
      '[data-testid="masthead-submenu-more-button"]',
      this.handleMoreSubmenuButtonClick,
      false,
      this.root
    );
    document.addEventListener("click", this.handleMoreSubmenuOutsideClick);
  }

  init() {
    this.bindSearchForm();
    this.bindToggleSearch();
    this.bindSearchCloseButton();
    this.bindMoreSubmenuToggle();
  }
}

export default () => {
  const root = document.querySelector(".js-made-category-print-masthead");
  if (!root) return;

  const instance = new MadeCategoryPrintMasthead(root);
  instance.init();
};
